'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import SwapForm from "./Form";
import { SWRConfig, mutate } from 'swr';
import ThemeWrapper from '../../../../components/themeWrapper';
export const Swap = () => {
    return (_jsx(ThemeWrapper, { children: _jsx("div", { className: "text-primary-text h-full", children: _jsx(SWRConfig, { value: { use: [updatePendingCount] }, children: _jsx(SwapForm, {}) }) }) }));
};
const swapsStatuses = {};
function updatePendingCount(useSWRNext) {
    return (key, fetcher, config) => {
        const swr = useSWRNext(key, fetcher, config);
        useEffect(() => {
            const swapKeyPattern = /^\/swaps\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/;
            // Update ref if data is not undefined.
            const swap = swr.data?.data;
            if (swapKeyPattern.test(key) && swap) {
                const status = swap.status;
                if (swapsStatuses[swap.id] !== status) {
                    mutate('/internal/swaps/count');
                }
                swapsStatuses[swap.id] = status;
            }
        }, [swr.data, key]);
        return swr;
    };
}
